import { useMedia } from 'shared/hooks';
import "./styles.scss"
import { ICONS } from 'shared/constants';
import { UiIcon } from 'shared/uikit';
import classnames from 'classnames';
import { MouseEvent } from 'react';
import { observer } from 'mobx-react';

type PPDWidgetBaseHeaderProps = {
    name?: string;
    isOpen?: boolean;
    onToggle?: () => void;
    isShowOptions?: boolean;
    onClickOptions?: (event: MouseEvent) => void;
    className?: string;
}

export const PPDWidgetBaseHeader = observer(({
    name = '',
    isOpen = false,
    onToggle,
    isShowOptions = false,
    onClickOptions,
    className,
}: PPDWidgetBaseHeaderProps) => {
    const { isMobileOrTablet } = useMedia();

    const shouldShowOptions =
        isShowOptions && (!isMobileOrTablet  || (isMobileOrTablet  && isOpen));

    return (
        <div
            className={classnames("ppd-widget-base-header", className, {
                "ppd-widget-base-header--open": isOpen,
            })}
            onClick={isMobileOrTablet && onToggle ? onToggle : undefined}
        >
            <div className="ppd-widget-base-header__main">
                <div className="ppd-widget-base-header__name">{name || "Без названия"}</div>
            </div>
            <div className="ppd-widget-base-header__box">
                { shouldShowOptions && (
                    <button
                        type="button"
                        className="ppd-widget-base-header__options"
                        onClick={onClickOptions ?? (() => {})}
                        disabled={!onClickOptions}
                    >
                        <UiIcon icon={ICONS.OPTIONS} size={24} color="#15171C" />
                    </button>
                )}
                { isMobileOrTablet  && (
                    <span className="ppd-widget-base-header__toggle">
                        <UiIcon icon={ICONS.CHEVRON_DOWN} size={16} color="#15171C" />
                    </span>
                )}
            </div>
        </div>
    );
});
